import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=b61706e6&"
import script from "./Teacher.vue?vue&type=script&lang=js&"
export * from "./Teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports